import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {Highlightable, ListKeyManagerOption} from '@angular/cdk/a11y';

@Component({
  selector: 'ds-list-group-item',
  templateUrl: './list-group-item.component.html',
  styleUrls: ['./list-group-item.component.scss']
})
export class ListGroupItemComponent implements Highlightable, ListKeyManagerOption {

  @ViewChild('listItem', {static: true}) element: ElementRef;
  @Input() isActive = false;
  @Input() value = '';
  @Input() disabled = false;
  @Input() hideDisabled = true;
  @Input() deactivated = false;
  @Input() label = '';
  @Input() displayCheckbox = false;
  @Input() itemTabIndex = null;
  @Input() isRowContent = false;
  @Output() elementClick = new EventEmitter<string>();
  highlighted: boolean;

  @Input() isEditable = false;
  @Input() isEditDisabled = false;
  @Input() editButtonText = 'Edit';
  @Input() editButtonTooltip: string;
  @Input() editButtonTooltipPlacement = 'bottom';
  @Output() editClick = new EventEmitter<string>();

  constructor() {
    this.highlighted = false;
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.selectElement();
    }
  }

  selectElement(): void {
    if (!this.deactivated && !this.disabled) {
      this.elementClick.emit(this.value);
    }
  }

  onEditClick(isDisabled: boolean) {
    if (!isDisabled) {
      this.editClick.next(this.value);
    }
  }

  getLabel(): string {
    return this.label;
  }

  setActiveStyles(): void {
    this.highlighted = true;
    // the setTimeout() is needed to resolve a timing issue in Firefox (DCP-8395)
    setTimeout(() => this.element.nativeElement.scrollIntoView({block: 'nearest'}));
  }

  setInactiveStyles(): void {
    this.highlighted = false;
  }
}
